import { FC, useState } from 'react';
import { Bell } from 'lucide-react';
import { Popover, PopoverTrigger } from '@new/common/ui/Popover/Popover';
import { NotificationsModal } from '../NotificationsModal/NotificationsModal';
import { useGetNotificationsQuery } from '@teachur/http-client';

export const NotificationsButton: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data } = useGetNotificationsQuery();
  const unreadCount = data?.unreadCount || 0;

  const handleClose = () => {
    setIsOpen(false);
  };

  const displayCount = unreadCount > 9 ? '9+' : unreadCount;
  const isDoubleDigit = unreadCount > 9;

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger
        className="relative hover:bg-gray-100 rounded-lg! transition-colors cursor-pointer"
        aria-label="Notifications"
      >
        <Bell className="w-6 h-6 text-gray-700" />

        {unreadCount > 0 && (
          <span
            className={`absolute -top-3 -right-2 bg-(--primary-O1000) text-(--neutral-white-NW1000) text-xs font-bold rounded-full flex items-center justify-center leading-tight!
              ${isDoubleDigit ? 'w-7 h-5 -right-2' : 'w-5 h-5'}
            `}
          >
            {displayCount}
          </span>
        )}
      </PopoverTrigger>

      <NotificationsModal onClose={handleClose} />
    </Popover>
  );
};
